import axios from "axios";

import {
    USER_SUCCESS_LOGIN,
    USER_FAILED_LOGIN,
    LOGOUT,
    API_HOST_URL
  } from "./types";

export const userActions = {
    login,
    logout
};
 

function login(data){
    return dispatch => {

        axios.post(API_HOST_URL + '/user/login', data)
        .then(res => {
            localStorage.setItem('token', res.data.token);
            dispatch(success(res.data.token));
        })
        .catch(error => {
            dispatch(failure(error.response.data.error));
        });
    }

    function success(user) { return { type: USER_SUCCESS_LOGIN, payload: user} }
    function failure(error) { return { type: USER_FAILED_LOGIN, payload: error } }
}

function logout() {
    localStorage.removeItem('token');
    return { type: LOGOUT };
}



// WEBPACK FOOTER //
// ./src/actions/user.js